import Vue from 'vue'
import axios from 'axios'
import { Message } from 'element-ui'

var instance = axios.create({
  baseURL: 'api',
  // baseURL: '',
  timeout: 600000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})
var axiosLogin = axios.create({
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json'
  }
})
instance.interceptors.request.use(config => {
  let url = window.location.href.split('http://')[1];
  let seconddomainname = url.substring(0, url.indexOf('.'))
  let loginName = null
  loginName = sessionStorage.getItem('loginName') || 'jjyxadmin@lygyhlw.com'
  config.headers.loginName = loginName
  // config.headers.Authorization = seconddomainname;
  return config;
}, err => {
  Message.error({ message: '请求超时!' });
  return Promise.resolve(err);
})

instance.interceptors.response.use(data => {
  switch (data.data.status) {
    // 成功获取数据，那么返回数据
    case 0:
      return data.data
    case true:
      return data
    // 数据重复
    // case 1:
    //   Message.error({
    //     message: data.data.msg
    //   })
    //   return Promise.reject(data)
    // case 3:
    //   Message.error({
    //     message: data.data.msg
    //   })
    //   // eslint-disable-next-line no-undef
    //   goto('/login')
    //   return Promise.reject(data)
    case 999:
      // console.log('case 999')
      Message.error({
        message: data.data.msg
      })
      // 阻断
      return Promise.reject(data)
    // 数据获取失败，状态码为非特殊状态码，返回后端错误信息
    default:
      Message.error({
        message: data.data.msg
      })
      return Promise.reject(data)
  }
},
  error => {
    // 响应失败，根据状态码由前端返回错误信息
    // endLoading()
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '错误请求'
          Message.error('错误请求')
          break
        case 401:
          error.message = '未授权，请重新登录'
          Message.error('未授权，请重新登录')
          break
        case 403:
          error.message = '拒绝访问'
          Message.error('拒绝访问')
          break
        case 404:
          error.message = '请求错误,未找到该资源'
          Message.error('请求错误,未找到该资源')
          break
        case 405:
          error.message = '请求方法未允许'
          Message.error('请求方法未允许')
          break
        case 408:
          error.message = '请求超时'
          Message.error('请求超时')
          break
        case 500:
          error.message = '服务器端出错'
          Message.error('服务器端出错')
          break
        case 501:
          error.message = '网络未实现'
          Message.error('网络未实现')
          break
        case 502:
          error.message = '网络错误'
          Message.error('网络错误')
          break
        case 503:
          error.message = '服务不可用'
          Message.error('服务不可用')
          break
        case 504:
          error.message = '网络超时'
          Message.error('网络超时')
          break
        case 505:
          error.message = 'http版本不支持该请求'
          Message.error('http版本不支持该请求')
          break
        default:
          error.message = `连接错误${error.response.status}`
          Message.error(`'连接错误'${error.response.status}`)
      }
    } else {
      error.message = '连接到服务器失败'
      Message.error('连接到服务器失败')
    }
    return Promise.reject(error.message)
  }
)
Vue.prototype.$axios = instance
Vue.prototype.$axiosLogin = axiosLogin
